import { ThemeUIStyleObject } from 'theme-ui';

export const containerStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  gap: '0.5rem',
  marginLeft: ['0.5rem', '2rem'], // mobile, desktop
  marginRight: ['0.5rem', '2rem'], // mobile, desktop
  marginTop: '0.5rem',
  marginBottom: '0.5rem',
  padding: ['0.5rem', '0.75rem'], // mobile, desktop
  borderRadius: '0.5rem',
  border: '1px solid',
  borderColor: 'neutral/200',
  bg: 'neutral/100',
};

export const tableContainerStyles: ThemeUIStyleObject = {
  bg: 'neutral/000',
  borderRadius: '0.25rem',
  overflowX: ['auto', 'visible'], // horizontal scroll on mobile
  WebkitOverflowScrolling: 'touch', // smooth scrolling on iOS

  // Mobile: smaller text to fit more content
  '& table': {
    fontSize: ['0.75rem', '1rem'], // mobile, desktop
    minWidth: ['500px', 'auto'], // prevent table from squishing on mobile
  },
};

export const placeholderStyles: ThemeUIStyleObject = {
  textAlign: 'center',
  padding: ['0.75rem', '1rem'], // mobile, desktop
  color: 'neutral/500',
};
